/**
 * 支払方法変更_受付中返却API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 支払方法変更情報
 */
export interface Sgkd036aResPaymtdChginfo {

    /**
     * 支払方法コード：半角英数混在
     */
    payMthdiv?: string;
    /**
     * 支払方法名称：全角文字
     */
    paymtdAname?: string;
}

